import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ObjAssocIcon.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const ObjAssocIcon: React.FC<RecordIconProps> = ({ record, index, handleLinkClick }) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    // Ophalen van de juiste velden
    const objectNumber = record?.data?.record?.objectnumber ?? "";
    const institution = record?.data?.record?.institution ?? "";
    const exhtitle = record?.data?.record?.exhtitle ?? "";
    const alphasort = record?.data?.record?.alphasort ?? "";

    // ✅ Gebruik `getImages()` om de correcte afbeelding te krijgen
    let imageUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}images/nondisponible.cci&width=140&height=100`; // Standaard afbeelding
    const allImages = getImages(record);
    if ((allImages as any)["list"]?.length > 0) {
        imageUrl = (allImages as any)["list"][0]?.url;
    }

    return (
        <a
            href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=[${objectNumber}]`}
            className={styles.ObjAssocIcon}
            key={index}
            onClick={(event) => handleLinkClick(event, index)}
            onMouseDown={(e) => e.preventDefault()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={styles.iconViewRecord}>
                <ImageWithFallback
                    src={imageUrl}
                    alt="Image"
                    height={100}
                    placeholder={`${process.env.REACT_APP_IMAGE_BASE_URL}images/nondisponible.cci&width=140&height=100`}
                />

                {isHovered && (
                    <div className={styles.hoverOverlay}>
                        <div className={styles.row}>{objectNumber}</div>
                        <div className={styles.row}>{institution}</div>
                        <div className={styles.row}>{alphasort}</div>
                        <div className={styles.row}>{exhtitle}</div>
                    </div>
                )}
            </div>
        </a>
    );
};

export default ObjAssocIcon;
